/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IGetManyUsersMessage extends IMessage {
	ids: string[];
}

export default class GetManyUsersMessage extends Message {
	public static readonly TYPE: string = '22';

	public static readonly READABLE_TYPE_NAME: string = 'getManyUsers';

	public static readonly DESCRIPTOR_NAME: string = 'GetManyUsersMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			ids: {
				id: 1,
				type: 'string',
				rule: 'repeated'
			}
		}
	};

	public constructor( public readonly ids: string[] ) {
		super();
	}

	public toJSON(): IGetManyUsersMessage {
		return {
			ids: this.ids
		};
	}

	public static fromJSON( data: IGetManyUsersMessage ): GetManyUsersMessage {
		return new GetManyUsersMessage( data.ids );
	}
}
